var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSquareGlyph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.657 28.636v-1.364H4.343a1.62 1.62 0 0 1-1.616-1.616V4.343a1.62 1.62 0 0 1 1.616-1.616h21.314a1.62 1.62 0 0 1 1.616 1.616v21.313a1.62 1.62 0 0 1-1.616 1.616zV30A4.345 4.345 0 0 0 30 25.656V4.343A4.344 4.344 0 0 0 25.657 0H4.343A4.345 4.345 0 0 0 0 4.343v21.313A4.347 4.347 0 0 0 4.343 30h21.314z"
})));
export default SvgSquareGlyph;